import { render, staticRenderFns } from "./Scrolling.vue?vue&type=template&id=cf0a2882&scoped=true&"
import script from "./Scrolling.vue?vue&type=script&lang=js&"
export * from "./Scrolling.vue?vue&type=script&lang=js&"
import style0 from "./Scrolling.vue?vue&type=style&index=0&id=cf0a2882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0a2882",
  null
  
)

export default component.exports